module.exports = __webpack_public_path__ + "static/media/02A.e08b4f16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/02A.png
// module id = 250
// module chunks = 0